enum EntitlementCalculationMethod {
  FIXED_AMOUNT= 'FIXED_AMOUNT',
  MULTIPLIER_OF_BASE_HOURS = 'MULTIPLIER_OF_BASE_HOURS',
  HOURS_PER_PAY = 'HOURS_PER_PAY'
}

export default EntitlementCalculationMethod;
